<template>
    <div id="v-particles"></div>
</template>

<style>
#v-particles {
    position: absolute;
    width: 100%;
    height: 100%;
}
</style>

<script>
export default {
    mounted() {
        require("particles.js");
        particlesJS("v-particles", {
            particles: {
                number: {
                    value: 160,
                    density: {
                        enable: true,
                        value_area: 600,
                    },
                },
                color: {
                    value: "#fff",
                },
                shape: {
                    type: "circle",
                    stroke: {
                        width: 0,
                        color: "#192231",
                    },
                },
                opacity: {
                    value: 0.6,
                    random: true,
                    anim: {
                        enable: true,
                        speed: 0.4,
                        opacity_min: 0.6,
                        sync: true,
                    },
                },
                size: {
                    value: 2,
                },
                line_linked: {
                    enable: false,
                    distance: 0,
                    color: "#ffffff",
                    opacity: 0,
                    width: 2,
                },
                move: {
                    speed: 0.4,
                },
                interactivity: {
                    detect_on: "canvas",
                    events: {
                        onhover: {
                            enable: true,
                            mode: "grab",
                        },
                        onclick: {
                            enable: true,
                        },
                        onresize: {
                            enable: true,
                            density_auto: true,
                            density_area: 400,
                        },
                    },
                },
                modes: {
                    grab: {
                        distance: 0,
                        line_linked: {
                            opacity: 0,
                        },
                    },
                },
            },
        });
    },
};
</script>
